import { Dialog, Pane, Button } from 'evergreen-ui';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { customListStyles } from '../../styles/sharedComponentStyles';

const useSharedStyles = createUseStyles({
  ...customListStyles,
  buttons: {
    marginTop: '10px',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '93%',
  },
  textWrapper: {
    margin: '30px',
  },
});

const ArchiveUserDialog = ({
  handleCloseModal,
  isShown,
  handleConfirm,
  isLoading,
}) => {
  const sharedClasses = useSharedStyles();
  return (
    <Dialog
      isShown={isShown}
      title="Archive User"
      onCloseComplete={handleCloseModal}
      hasCancel={false}
      hasFooter={false}
      preventBodyScrolling
      confirmLabel="Confirm"
    >
      <Pane className={sharedClasses.textWrapper}>
        Are you sure you want to archive this user?
      </Pane>
      <Pane className={sharedClasses.buttons}>
        <Button
          className={sharedClasses.buttonStylesSecondary}
          onClick={handleCloseModal}
        >
          Cancel
        </Button>
        <Button
          className={sharedClasses.buttonStylesDanger}
          isLoading={isLoading}
          onClick={handleConfirm}
        >
          Confirm
        </Button>
      </Pane>
    </Dialog>
  );
};

export default ArchiveUserDialog;
